import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "지속적 통합",
  "description": "Vercel, GitHub Actions 및 기타 지속적 통합 제공자와 함께 Turborepo를 사용하기 위한 레시피입니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo는 빌드 속도를 높일 뿐만 아니라 Remote Caching을 사용하여 지속적 통합 파이프라인의 나머지 부분도 가속화합니다. 아래는 CI 제공자와 함께 Turborepo를 사용하기 위한 몇 가지 플랫폼 레시피입니다."
  }, {
    "heading": "일반-설정",
    "content": "CI에 대해 Remote Caching을 활성화하려면:"
  }, {
    "heading": "일반-설정",
    "content": "Remote Cache에 액세스하기 위해 CI에서 Turborepo에 대한 환경 변수를 설정합니다."
  }, {
    "heading": "일반-설정",
    "content": "변수"
  }, {
    "heading": "일반-설정",
    "content": "설명"
  }, {
    "heading": "일반-설정",
    "content": "TURBO_TOKEN"
  }, {
    "heading": "일반-설정",
    "content": "Remote Cache에 액세스하기 위한 Bearer 토큰"
  }, {
    "heading": "일반-설정",
    "content": "TURBO_TEAM"
  }, {
    "heading": "일반-설정",
    "content": "저장소와 연결된 계정 이름. Vercel Remote Cache를 사용할 때 이것은 팀의 슬러그입니다."
  }, {
    "heading": "일반-설정",
    "content": "저장소를 복제합니다."
  }, {
    "heading": "일반-설정",
    "content": "패키지 매니저를 통해 의존성을 설치합니다."
  }, {
    "heading": "일반-설정",
    "content": "turbo를 통해 작업을 실행합니다."
  }],
  "headings": [{
    "id": "일반-설정",
    "content": "일반 설정"
  }]
};
import {Cards, Card} from '#components/card';
export const toc = [{
  depth: 2,
  url: "#일반-설정",
  title: _jsx(_Fragment, {
    children: "일반 설정"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    ol: "ol",
    p: "p",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo는 빌드 속도를 높일 뿐만 아니라 ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Caching"
      }), "을 사용하여 지속적 통합 파이프라인의 나머지 부분도 가속화합니다. 아래는 CI 제공자와 함께 Turborepo를 사용하기 위한 몇 가지 플랫폼 레시피입니다."]
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        title: "Vercel (Zero configuration)",
        href: "/docs/guides/ci-vendors/vercel"
      }), _jsx(Card, {
        title: "GitHub Actions",
        href: "/docs/guides/ci-vendors/github-actions"
      }), _jsx(Card, {
        title: "CircleCI",
        href: "/docs/guides/ci-vendors/circleci"
      }), _jsx(Card, {
        title: "GitLab CI",
        href: "/docs/guides/ci-vendors/gitlab-ci"
      }), _jsx(Card, {
        title: "Travis CI",
        href: "/docs/guides/ci-vendors/travis-ci"
      }), _jsx(Card, {
        title: "Buildkite",
        href: "/docs/guides/ci-vendors/buildkite"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "일반-설정",
      children: "일반 설정"
    }), "\n", _jsx(_components.p, {
      children: "CI에 대해 Remote Caching을 활성화하려면:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Remote Cache에 액세스하기 위해 CI에서 Turborepo에 대한 환경 변수를 설정합니다.", "\n", _jsxs(_components.table, {
          children: [_jsx(_components.thead, {
            children: _jsxs(_components.tr, {
              children: [_jsx(_components.th, {
                children: "변수"
              }), _jsx(_components.th, {
                children: "설명"
              })]
            })
          }), _jsxs(_components.tbody, {
            children: [_jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                children: _jsx(_components.code, {
                  children: "TURBO_TOKEN"
                })
              }), _jsx(_components.td, {
                children: "Remote Cache에 액세스하기 위한 Bearer 토큰"
              })]
            }), _jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                children: _jsx(_components.code, {
                  children: "TURBO_TEAM"
                })
              }), _jsxs(_components.td, {
                children: ["저장소와 연결된 계정 이름. ", _jsx("a", {
                  href: "https://vercel.com/docs/monorepos/remote-caching#vercel-remote-cache",
                  rel: "noreferrer noopener",
                  target: "_blank",
                  children: "Vercel Remote Cache"
                }), "를 사용할 때 이것은 ", _jsx(_components.a, {
                  href: "https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fsettings&title=Get+team+slug",
                  children: "팀의 슬러그"
                }), "입니다."]
              })]
            })]
          })]
        }), "\n"]
      }), "\n", _jsx(_components.li, {
        children: "저장소를 복제합니다."
      }), "\n", _jsx(_components.li, {
        children: "패키지 매니저를 통해 의존성을 설치합니다."
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo"
        }), "를 통해 작업을 실행합니다."]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
